var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9977 0.117188C4.47483 0.117188 -0.00231934 4.59434 -0.00231934 10.1172C-0.00231934 15.1085 3.65453 19.2455 8.4352 19.9957V13.0078H5.89611V10.1172H8.4352V7.91407C8.4352 5.40782 9.9281 4.02344 12.2123 4.02344C13.3064 4.02344 14.4508 4.21875 14.4508 4.21875V6.67969H13.1898C11.9476 6.67969 11.5602 7.45053 11.5602 8.24139V10.1172H14.3336L13.8903 13.0078H11.5602V19.9957C16.3408 19.2455 19.9977 15.1085 19.9977 10.1172C19.9977 4.59434 15.5205 0.117188 9.9977 0.117188Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d0e6bd93d552eb65e3b41f7ea85c648b.svg";
export { ForwardRef as ReactComponent };